import React from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLoginContext } from "../context/LoginContext";
import { postRequest } from "../services/apiMethods";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";

export default function Credits() {
  const { userData, refresh } = useLoginContext();
  console.log(userData, "userDatauserDatauserDatauserData34534")

  const Navigate = useNavigate();



  const { mutate, isLoading } = useMutation({
    mutationFn: (data) => {
      return postRequest("lead/credit", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        window.location.href = `${data?.data?.url}`;
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });



  const handlePurchaseaddOwns = (price) => {
    if (userData?.activePlan?.name) {

      const payload = {
        amount: Number(price),
      };
      mutate(payload);
    } else {
      toast.error("Need a subscription to buy top-ups.")
    }

  }


  // console.log("534534535343", userData?.activePlan?.name)
  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate("/settings")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>
            <Row>
              <Col lg={8}>
                <div className="my-profile-card-contain">
                  <div className="my-profile-title">
                    <h4>Credits</h4>
                    <p>You can top up any time if you run out!</p>
                  </div>
                  <div className="my-profile-box-contain">
                    <div className="my-profile-box-form">
                      <div className="credits-list">
                        <div class="form-box-title">
                          <h4>10 Quotes</h4>
                          <p className="m-1">10 additional quotes</p>
                        </div>
                        <div>
                          <h4 className="m-0">£90.00</h4>
                        </div>
                        <div>
                          <button className="theme-comm-btn" disabled={isLoading} onClick={() => handlePurchaseaddOwns("90")}>Purchase</button>
                        </div>
                      </div>
                    </div>
                    <div className="my-profile-box-form">
                      <div className="credits-list">
                        <div class="form-box-title">
                          <h4>20 Quotes</h4>
                          <p className="m-1">20 additional quotes</p>
                        </div>
                        <div>
                          <h4 className="m-0">£130.00</h4>
                        </div>
                        <div>
                          <button className="theme-comm-btn" disabled={isLoading} onClick={() => handlePurchaseaddOwns("130")} >Purchase</button>
                        </div>
                      </div>
                    </div>
                    <div className="my-profile-box-form">
                      <div className="credits-list">
                        <div class="form-box-title">
                          <h4>50 Quotes</h4>
                          <p className="m-1">50 additional quotes</p>
                        </div>
                        <div>
                          <h4 className="m-0">£180.00</h4>
                        </div>
                        <div>
                          <button className="theme-comm-btn" disabled={isLoading} onClick={() => handlePurchaseaddOwns("180")}>Purchase</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="my-profile-title mt-4">
                    <h4>Your Subscription</h4>
                    <p>You can top up any time if you run out!</p>
                  </div>

                  {userData?.activePlan?.name ?
                    <div className="my-profile-box-form">
                      <div className="credits-list">
                        <div class="form-box-title">
                          <h4>{userData?.activePlan?.name}</h4>

                          {userData?.activePlan?.name == "Premium" ? <p className="m-1">20 quotes per month</p> :
                            <p className="m-1">10 quotes per month</p>}

                        </div>
                        <div>

                          <h4 className="m-0"> {`£${userData?.activePlan?.amount}.00 per month`} </h4>
                        </div>
                        <div>
                          <button className="theme-white-comm-btn" onClick={() => Navigate("/your-subscription")}>Manage</button>
                        </div>
                      </div>
                    </div> :

                    <div className="my-profile-box-form">
                      <div className="credits-list">
                        <div class="form-box-title">
                          <h4></h4>
                          <p className="m-0"></p>
                        </div>
                        <div>
                          <h5 className="m-0"> Buy a Subscription Plan  to purchase leads </h5>
                        </div>
                        <div>
                          <button className="theme-comm-btn" onClick={() => Navigate("/your-subscription")}>Subscribe</button>
                        </div>
                      </div>
                    </div>}

                </div>
              </Col>
              <Col lg={4}></Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
